import clsx from 'clsx';
import { useValue } from '../hooks/useValue';
import './controls.css';
import type { FormControlProps } from './FormControl';
import { useId } from 'react';

export interface SwitchProps extends FormControlProps<boolean> {
  width?: number;
}

export function Switch(props: SwitchProps) {
  const internalId = useId();

  const {
    id = internalId,
    name = id,
    className,
    checked: initialChecked,
    disabled,
    width = 56,
    onChange,
    tabIndex = 0,
    children,
  } = props;

  const { value: checked, setValue } = useValue<boolean>({
    initialValue: initialChecked,
    name,
    onChange,
  });

  return (
    <label
      className={clsx(className, 'relative flex items-center gap-[10px]', {
        'text-b2': !className?.includes('text-'),
        'font-semibold': !className?.includes('font-'),
        'text-grey': disabled,
        'cursor-pointer': !disabled,
      })}
      data-testid="SwitchContainer"
    >
      <span className="relative">
        <input
          type="checkbox"
          name={name}
          tabIndex={tabIndex}
          checked={checked}
          disabled={disabled}
          role="switch"
          className="absolute w-full h-full opacity-0 cursor-pointer"
          onChange={() => {
            if (!disabled) {
              setValue(!checked);
            }
          }}
          data-name="Switch"
        />

        <span style={{ height: (width * 4) / 7, width }}>
          <svg viewBox="0 0 24 24" width={(width * 3) / 7}>
            <g>
              <circle cx={12} cy={12} r={12} fill="var(--color-white)" />
              <circle cx={12} cy={12} r={4} fill="var(--color-grey)" />
            </g>
          </svg>
        </span>
      </span>

      <span>{children}</span>
    </label>
  );
}
